import type { ToolsStore } from './interfaces'

export const actions = {
  _setAnalyticsFirstSuccessInit (this: ToolsStore, payload: boolean): void {
    this._analyticsFirstSuccessInit = payload
  },
  setClarityReady (this: ToolsStore, payload: ToolsStore['clarityReady']): void {
    this.clarityReady = payload
  },
  setMetaPixelReady (this: ToolsStore, payload: ToolsStore['metaPixelReady']): void {
    this.metaPixelReady = payload
  },
}
